module.exports = __webpack_public_path__ + "static/media/Art3.5097d951.pdf";